export default __webpack_public_path__ + "media/images/planning-cedeaa1c03d6a9fd0758f4d996d70fdc.svg";